<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="home-page">
      <Header :isRestoCompleto="!firstTime" ></Header>
      <div class="col-lg-8 mx-auto p-3 py-md-5">
        <main>
        

          <div class="row">
    <div class="col-2"  >
      <a href="#"   @click="goToPage('Servicios', $event)" v-if="!firstTime" >
      <p class="h5 mb-2"> <b-icon-arrow-left></b-icon-arrow-left>Atrás</p>
    </a>
    </div>
    <div class="col-8">
      <h3>Especialidades</h3>
    </div>
    <div class="col-2">
      <a href="#" v-on:click="guardarCambios()" v-if="!firstTime">
      <p class="h5 mb-2">Siguiente<b-icon-arrow-right></b-icon-arrow-right></p>
    </a>
    </div>
  </div>


          <hr class="" />

          <div class="alert alert-primary" role="alert">
  El objetivo de la pantalla es que muestres a los clientes que servicios tienes para que ellos elijan
</div>

          <form v-on:submit.prevent="guardarCambios">
            <table class="table table-responsive table-striped align-middle">
              <thead>
                <tr>
                  <th scope="col">Especialidad</th>
                  <th scope="col">Seleccionado</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="especialidad in especialidades"
                  :key="especialidad.id"
                >
                  <td>
                    <label class="col-sm-4 col-form-label">{{
                      especialidad.descripcion
                    }}</label>
                  </td>
                  <td class="text-center">
                    <input
                      class="form-check-input"
                      v-model="especialidadesSelected"
                      :value="especialidad.id"
                      type="checkbox"
                      role="switch"
                      active="false"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="d-grid d-md-flex justify-content-md-center">
              <button
                class="btn btn-primary"
                type="submit"
                :disabled="isFormEnable"
                v-if="!firstTime"
              >
                Guardar cambios
              </button>
              <button
                class="btn btn-primary"
                @click="goToPage('Servicios', $event)"
                v-if="firstTime"
              >
                Anterior
              </button>
              <button class="btn btn-primary" type="submit" v-if="firstTime">
                Siguiente
              </button>
            </div>
          </form>
          <PopUp
            :show="success"
            @close="
              success = false;
              if (firstTime) goToPageFirstTime('RegistrarMesa');
            "
          >
            <template #body>
              <p>{{ success_msg }}</p>
            </template>
          </PopUp>
          <PopUp :show="error" @close="error = false">
            <template #body>
              <p>{{ error_msg }}</p>
            </template>
          </PopUp>
        </main>
        <Footer />
      </div>
    </body>
  </html>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUp from "../components/PopUp.vue";
import { cloneDeep, isEqual } from 'lodash'
export default {
  name: "Especialidades",
  components: { Header, Footer, PopUp },
  data: function () {
    return {
      firstTime: false,
      restaurante: Object,
      especialidad: "",
      especialidades: [],
      especialidadesSelected: [],
      originalEspecialidadesSelected: [],
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
    };
  },
  methods: {
    cargarEspecialidades() {
      
      axios
        .get("/restaurante/mail")
        .then((data) => {
          if (data.status == 200) {
            this.restaurante = data.data;
            this.especialidadesSelected = this.restaurante.especialidades.map(especialidad => especialidad.id);
            this.originalEspecialidadesSelected = cloneDeep(this.especialidadesSelected);
          }
        })
        .catch(() => {
          this.error = true;
          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });
      axios
        .get("/getEspecialidades/")
        .then((data) => {
          if (data.status == 200) {
            if (data.data != null) {
              this.especialidades = data.data;
            } else {
              this.especialidades = new Array();
            }
          }
        })
        .catch(() => {
          this.error = true;
          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });
    },
    guardarCambios() {
      let json = {
        especialidades: this.especialidadesSelected,
      };
      console.log(json);

      axios
        .post("/agregarEspecialidades", json)
        .then((data) => {
          if (data.status == 200) {
            this.success = true;
            this.success_msg =
              "Se ha logrado guardar las especialidades con exito";
            this.cargarEspecialidades();
          } else {
            this.error = true;
            this.error_msg =
              " No se ha podido guardar los cambios. Intente nuevemente mas tarde";
          }
        });
    },
    goToPageFirstTime(page) {
      this.$router.push({ name: page, params: { firstTime: true } });
    },
    goToPage(page, $event) {
      this.$router.push({ name: page});
      $event?.preventDefault();
    },
  },
  beforeMount() {
    this.cargarEspecialidades();
  },
  computed: {
    isFormEnable() {
      // check if it's original value
      if (!isEqual(this.especialidadesSelected, this.originalEspecialidadesSelected)) return false;

      return true;
    }

  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
.btn-primary {
  margin: 15px;
}
</style>
